import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "adblock-confirm__content" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "adblock-confirm__title" }, " Úgy látjuk, reklámblokkolót használsz. ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "adblock-confirm__body" }, " Az RTL.hu hirdetésekből tartja fent magát, így tudjuk biztosítani a mindig naprakész, pártatlan híreket, szórakoztató tartalmainkat. ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "adblock-confirm__body" }, " Kérjuk, támogasd a munkánkat, és kapcsold ki a hirdetések blokkolását! ", -1)
const _hoisted_5 = { class: "adblock-confirm__footer" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Hogy tudom kikapcsolni? ")
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "adblock-confirm__backdrop" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Close = _resolveComponent("Close")!
  const _component_main_logo = _resolveComponent("main-logo")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.show)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "adblock-confirm",
        onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.toggle(false, 'close')), ["self"]))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_Close, {
            class: "adblock-confirm__close",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggle(false, 'close')))
          }),
          _createVNode(_component_main_logo, { class: "adblock-confirm__logo" }),
          _hoisted_2,
          _hoisted_3,
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              class: "adblock-confirm__button button button--primary",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggle(false, 'select')))
            }, " Rendben "),
            _createVNode(_component_router_link, {
              class: "adblock-confirm__button button button--ghost",
              to: '/reklamblokkolo-kikapcsolasa',
              target: "_blank",
              onClickCapture: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggle(false, 'turnoff')))
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            })
          ])
        ]),
        _hoisted_7
      ]))
    : _createCommentVNode("", true)
}